export const hireFlutterPageContent = {
  // Helmet Content
  helmet: {
    title: "Hire Expert Flutter Developers",
    description: "Looking to hire skilled Flutter developers? Bitsclan offers pre-vetted, experienced professionals to build high-quality, feature-rich apps. Schedule a call today to get started!",
  },

  // HirePageBanner Content
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/hire-flutter.avif)`,
    shortHeading: "Hire Dedicated Flutter App Developers",
    mainHeading: "From Concept to <span>Market Flutter Apps</span> That Power Business Growth",
    content: "If you are looking to hire qualified dedicated Flutter developers, coders & programmers go no further than Bitsclan, which has the best Flutter developers for hire. We are an established nearshore Flutter app development firm. We use the Flutter cross-platform framework to create reliable apps for android & iOS that will take your business to new heights.",
    btnText: "Consult our Flutter developers",
    bannerList: [
      { list: "Freelance contractors" },
      { list: "Full-time roles" },
      { list: "Global teams" },
    ],
  },

  // HirePageExperties Content
  flutterExpertise: {
    btnText: "Hire Flutter Developers For Any Service",
    shortHeading: "Our Flutter Development Services",
    heading: "Building Scalable, High-Performance Flutter Apps That Drive Business Growth",
    description: "We specialize in delivering top-notch Flutter app development services customized to your business goals. Our experienced developers design high-performing, feature-packed, multi-platform applications that run seamlessly on iOS, android, Mac & web. As a <a href='/custom-software-development-services' class='text-black' target='_blank'>trusted Flutter app development</a> company, we provide dedicated Flutter experts who create intuitive, reliable, & future-ready mobile experiences.",
    servicesData: [
      {
        title: "Custom Cross-Platform Apps for Growth",
        description: "We provide custom Flutter app development services to build secure, scalable, & feature-rich applications. Our Flutter app expertise covers iOS, android, cross-platform, & desktop solutions, ensuring consistent user experiences, faster delivery, reduced costs, & powerful apps that drive engagement, performance, & measurable business growth.",
        icon: "/images/hire-page-icons/flutter-icon-1.svg",
      },
      {
        title: "High-Performance Flutter Web Solutions",
        description: "Unlock advanced web solutions with Flutter’s latest capabilities. Our best Flutter programmers build responsive, high-performing web apps from a single codebase for macOS, Windows, Linux, & ChromeOS. Delivering mobile-like experiences on browsers, we create scalable, cost-effective, & <a href='/web-app-development-services' class='text-black' target='_blank'>custom web apps</a> that maximize reach & engagement across platforms.",
        icon: "/images/hire-page-icons/flutter-icon-2.svg",
      },
      {
        title: "IoT-Integrated Mobile Apps",
        description: "If your aim is to surpass competitors with an engaging & interactive UI & UX design in your mobile apps, we have dedicated Flutter developers, experts, & specialists that can assist you to accomplish that & ensure your app attracts user attention, reinforces engagement, & delivers memorable digital experiences.",
        icon: "/images/hire-page-icons/flutter-icon-3.svg",
      },
      {
        title: "Embedded Device Flutter Solutions",
        description: "Flutter for IoT app development enables creating cross-platform apps with native-like performance. Using Dart & extensive widget libraries, our expert flutter mobile app developers build responsive UIs, integrate embedded devices, & connect seamlessly through platform channels, delivering scalable, feature-rich mobile solutions for both iOS & android platforms.",
        icon: "/images/hire-page-icons/flutter-icon-4.svg",
      },
      {
        title: "Seamless Flutter App Migration",
        description: "Our Flutter developers develop advanced solutions for embedded devices such as smart displays, IoT devices, thermostats, etc. The feature-rich APIs allow for smooth integration, high performance, & reliable access for users. We also offer businesses the option to hire remote Flutter developers to design their applications that scale & work effectively.",
        icon: "/images/hire-page-icons/flutter-icon-5.svg",
      },
      {
        title: "Strategic Flutter Consulting",
        description: "We ensure seamless migration & upgrades for your apps without disruptions. Our dedicated Flutter developers re-engineer outdated or native systems into Flutter, & are expert in boosting performance, preserving data, enhancing user experience & also modernizing your business operations for long-term scalability.",
        icon: "/images/hire-page-icons/flutter-icon-6.svg",
      },
      {
        title: "Ongoing Flutter Support & Maintenance",
        description: "We provide expert Flutter consulting services to help you determine if Flutter is the right choice for your app. Our vetted-pro Flutter consultants analyze your project goals, recommend tailored strategies, & guide smooth flutter integration services to ensure high performance, scalability, & efficiency for your mobile development journey.",
        icon: "/images/hire-page-icons/flutter-icon-7.svg",
      },
      {
        title: "Flutter Support & Maintenance",
        description: "We provide flutter ongoing support & maintenance services with dedicated flutter app development. Our team ensures smooth performance, quick issue resolution, & compatibility with updates, adapting seamlessly to user needs. From upgrades to bug fixes, we keep your flutter applications reliable & future-ready.",
        icon: "/images/hire-page-icons/flutter-icon-8.svg",
      },
    ],
  },

  // DevelopmentPerformance Content (Why Choose Us)
  whyChooseUs: {
    shortHeading: "Flutter App Developers You Can Count on",
    greenHeading: "Your Trusted Partner",
    mainHeading: " in Flutter App Success",
    description: "We are a trusted Flutter app development company in the USA, offering expert developers who deliver scalable, cross-platform flutter app solutions. Our team of expert flutter engineers ensures quality, timely delivery, & ongoing support to elevate your businesses through seamless & customized Flutter applications.",
    statsData: [
      // {
      //   number: "2017",
      //   title: "Flutter Services Since"
      // },
      {
        number: "140+",
        title: "Flutter Success Stories"
      },
      {
        number: "100+",
        title: "Flutter Engineers"
      },
      {
        number: "14+",
        title: "Flutter App Solutions Industries"
      },
    ]
    // btnText: "Hire a developer today",
    // heading: "Why Hire Flutter Developers ",
    // greenHeading: "from Bitsclan?",
    // subHeading: "At Bitsclan, we leverage Flutter’s capabilities with the latest mobile & web technologies to deliver robust, scalable, & high-performance applications customized to your business needs.",
    // solutionsData: [
    //   {
    //     icon: "/images/hire-page-icons/chose-ror-section1.svg",
    //     title: "Access vetted talent",
    //     description: "Meet experienced Flutter developers who are well-versed in the Flutter framework & are ready to contribute to your project.",
    //   },
    //   {
    //     icon: "/images/hire-page-icons/chose-ror-section2.svg",
    //     title: "View matches in seconds",
    //     description: "Forget the hassle of sorting through hundreds of resumes. With HireAI, you can instantly view the profiles of top Flutter developers.",
    //   },
    //   {
    //     icon: "/images/hire-page-icons/chose-ror-section3.svg",
    //     title: "Save with global hires",
    //     description: "Hire talented Flutter experts from anywhere in the world. You’ll access a vast pool of developers & save up to 58% compared to traditional hiring methods.",
    //     noBorder: true,
    //   },
    //   {
    //     icon: "/images/hire-page-icons/chose-ror-section4.svg",
    //     title: "Get real human support",
    //     description: "With our team of expert recruiters, you get personalized help to hire the best Flutter developers for your project.",
    //   },
    // ],
  },

  // HireCombinationSection Content
  techCombinations: {
    shortHeading: "Technologies We Use In Combination with Flutter",
    heading: "Powering Flutter Apps with Strategic Technology Integrations",
    description: "At Bitsclan, we provide full Flutter app solutions. We use many front-end & back-end technologies combinations with flutter & provide the apps that are scalable, cross-platform, lightweight & can accommodate various client needs in a creative & efficient manner.",
    combinations: [
      {
        title: "Flutter + Firebase",
        description:
          "Flutter for cross-platform development & Firebase as a backend solution enable real-time data sync, authentication, & cloud storage for mobile & web apps.",
        icons: [
          {
            icon: "Flutter.svg",
            altText: "Flutter mobile framework",
          },
          {
            icon: "firebase.png",
            altText: "Firebase backend service",
          },
        ],
      },
      {
        title: "Flutter + Node.js + MongoDB",
        description:
          "Flutter for the front end, Node.js for backend logic, & MongoDB for flexible NoSQL storage help create scalable & dynamic applications.",
        icons: [
          {
            icon: "Flutter.svg",
            altText: "Flutter mobile framework",
          },
          {
            icon: "nodejs.svg",
            altText: "Node.js server runtime",
          },
          {
            icon: "mongodb.svg",
            altText: "MongoDB NoSQL database",
          },
        ],
      },
      {
        title: "Flutter + Django + PostgreSQL",
        description:
          "Flutter for UI, Django as the backend framework, & PostgreSQL for structured database management ensure secure & high-performance app development.",
        icons: [
          {
            icon: "Flutter.svg",
            altText: "Flutter mobile framework",
          },
          {
            icon: "django.svg",
            altText: "Django Python framework",
          },
          {
            icon: "postgres.svg",
            altText: "PostgreSQL relational database",
          },
        ],
      },
      {
        title: "Flutter + GraphQL + Supabase",
        description:
          "GraphQL for efficient data fetching, Flutter for UI, & Supabase as an open-source backend solution provide a modern tech stack for mobile & web applications.",
        icons: [
          {
            icon: "Flutter.svg",
            altText: "Flutter mobile framework",
          },
          {
            icon: "graphql.svg",
            altText: "GraphQL query language",
          },
          {
            icon: "supabase.svg",
            altText: "Supabase open-source backend",
          },
        ],
      },
    ]
  },

  // HirePageSteps Content
  hireSteps: {
    btnText: "Let’s Find Your Perfect Developer",
    heading: "Hire Flutter Developers in 4 Easy Steps",
    subHeading: "Hiring expert Flutter developers is simple with our 4-step process. We focus on making sure you get the right developer for your project—fast, reliable, & cost-effective.",
    steps: [
      {
        title: "Choose your Engagement Model",
        description: "Pick the engagement model that fits your needs—Full-Time, Part-Time, or Hourly.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "Screen & Select Flutter Developers",
        description: "Browse through the profiles of top Flutter developers & select the best ones for your project.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "Conduct One-on-One Interview",
        description: "Meet with the developers you’ve selected & assess their skills through practical & theoretical questions.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
      {
        title: "Onboard Your Flutter Developer",
        description: "Once you've made your selection, your chosen Flutter developer will join your team within 24-48 hours, ensuring a fast & smooth onboarding process.",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
      },
    ],
  },

  // CoverTheStack Content
  coverTheStack: {
    whereStart: "Backend",
    shortHeading: "Flutter App Development Tools & Technologies We Work With",
    mainHeading: "Leveraging Advanced Tech Stacks to Power High-Performance Flutter Apps",
    subHeading: "Our Flutter app developers in the US help to integrate the latest technology stack & frameworks for your business solutions. From the Flutter SDK (Flutter Software Development Kit) & Dart programming language to third-party Flutter app development tools, we ensure your app is built with the latest industry standards, including integrations with Firebase & backend solutions.",
    tabs: [
      "Backend",
      "Database",
      "Cloud Services",
    ],
    tabItems: [
      { tab: "Backend", icon: "/images/tech-stack-icons/dart.svg", name: "Dart" },
      { tab: "Backend", name: "Firebase", icon: "/images/tech-stack-icons/firebase.png", },
      { tab: "Backend", name: "Node.js", icon: "/images/database9.png", },
      { tab: "Database", icon: "/images/db1.png", name: "Firebase" },
      { tab: "Database", icon: "/images/db7.png", name: "SQLite" },
      { tab: "Cloud Services", icon: "/images/cloud3.png", name: "AWS" },
      { tab: "Cloud Services", name: "Google Cloud", icon: "/images/cloud1.png", },
    ],
  },

  // HireExpertFacts Content
  expertFacts: {
    btnText: "book an appointment",
    heading: "Quick Facts About ",
    greenHeading: "Our Flutter Team",
    facts: [
      { text: "<strong>Experienced Flutter Developers:</strong> Our team includes highly skilled developers with expertise in Flutter app development." },
      { text: "<strong>Diverse Project Experience:</strong> We’ve successfully worked on a wide range of mobile app development projects, building cross-platform solutions with Flutter." },
      { text: "<strong>Fast & Efficient Development:</strong> Our developers use the Flutter framework to create apps quickly while ensuring they are high-quality & scalable." },
      { text: "<strong>Proven Record in Mobile App Development:</strong> Our team has a deep understanding of Dart programming & the Flutter framework to deliver top-notch mobile apps." },
      { text: "<strong>Cross-Platform Expertise:</strong> Whether it's iOS or android, we specialize in creating apps that perform well on both platforms." },
      { text: "<strong>Continuous Support:</strong> Our Flutter developers provide full support throughout the development process & beyond, helping with maintenance & updates." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-flutter.avif)`,
  },

  // HirePageAppIdea Content
  appIdeaSection: {
    heading: "Not sure about your app idea? Get your prototype up in 6-8 weeks!",
    content: "Have an idea but unsure how to proceed? Our Flutter experts can help you build a functional prototype in just 6-8 weeks! Validate your vision, test user engagement, & establish a strong foundation for success with our expert mobile app development services.",
  },

  // HirePageEngagementModels Component Props
  hirePageEngagementModels: {
    btnText: "Get Started Now",
    headingContent: [
      { text: "Our Flexible" },
      { text: "Engagement Models" },
    ],
    discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
    hiringDetails: [
      {
        text: "Hourly Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Start work in "
      },
      {
        text: "Full Time Hiring",
        hours: "72",
        timeUnit: "hours",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Get started within "
      },
      {
        text: "Part Time Hiring",
        hours: "48",
        timeUnit: "hours",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "Duration",
        duration: "8 Hrs/Day",
        minimumDaysLabel: "Minimum Days",
        minimumDays: "30 Days",
        billingLabel: "Billing",
        billing: "Monthly",
        startWorkPhrase: "Launch in "
      },
    ],
  },

  // SecondFaq Content
  faqSection: {
    mainHeading: "Flutter Development Questions & Answers",
    subHeading: "Discover answers to common questions about Flutter.",
    faqData: [
      {
        id: "collapseOne",
        question: "What are the benefits of choosing Flutter for app development?",
        answer:
          "Flutter development makes app creation faster with its hot reload, enables one codebase for multiple platforms, & offers rich widgets that deliver visually stunning apps while lowering costs & development time.",
      },
      {
        id: "collapseTwo",
        question: "How long does it take to build a Flutter app?",
        answer:
          "The timeline depends on your project’s complexity & features. On average, a Flutter app may take between 3 & 9 weeks, but requirements & integrations can extend or shorten development time.",
      },
      {
        id: "collapseThree",
        question: "Can I hire offshore Flutter developers for my project?",
        answer:
          "Yes, we offer offshore Flutter development services. You can hire dedicated Flutter developers from Bitsclan to access top-tier expertise, ensure flexibility, & maintain cost-effective solutions for your app development project.",
      },
      {
        id: "collapseFour",
        question: "How can I make sure my Flutter app is optimized?",
        answer:
          "Our Flutter developers focus on performance optimization by reducing UI complexity, reusing widgets, & using techniques like lazy loading, ensuring your app delivers a seamless & efficient experience across devices.",
      },
      {
        id: "collapseFive",
        question: "How does Flutter differ from other cross-platform frameworks?",
        answer:
          "Unlike React Native, which relies on a JavaScript bridge, Flutter compiles directly into native ARM code. This gives Flutter apps smoother performance, faster development cycles, & a more native-like user experience.",
      },
      {
        id: "collapseSix",
        question: "Do you provide after-sales support & maintenance for Flutter apps?",
        answer:
          "Yes, we provide ongoing after-sales support for Flutter apps. Depending on the project, clients receive free maintenance for a defined period, along with quick, responsive assistance. After this duration, affordable extended support is available to ensure lasting success.",
      },
    ]
  },
  // You can remove other individual exports if they are now nested.
  // For example, if 'bannerList' is only used within 'mainBanner', it doesn't need to be a separate export.
  // I've kept them as separate for now, but you can clean them up.
};


export const comapnyCtaContent = {
  heading: "Ready to Turn Data into Your Competitive Advantage?",
  subHeading: "Hire world class Data Scientists and Engineers to design, build, and optimize your data systems powering smarter business decisions.",
  buttonText: "Schedule a Call",
}